module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-utilities"
  }, [_c('h2', [_vm._v("更新水电表信息")]), (!_vm.indialog && !_vm.$config.logic.manual_meter) ? [_c('router-link', {
    staticClass: "ui themed button",
    attrs: {
      "to": ("/room/" + _vm.no + "/charge")
    }
  }, [_vm._v("空房水电充值")]), _c('br'), _c('br')] : _vm._e(), _c('div', {
    staticClass: "ui four columns stackable grid"
  }, _vm._l((_vm.utilities), function(utility, index) {
    return _c('div', {
      staticClass: "column"
    }, [_c('utility-view', {
      key: index,
      attrs: {
        "data": utility,
        "fallback": _vm.room.utilities[index],
        "paid": _vm.utilities_paid
      }
    }), _c('div', {
      staticClass: "ui form"
    }, [(!_vm.$config.logic.manual_meter) ? _c('div', {
      staticClass: "ui field"
    }, [_c('label', [_vm._v("数字表剩余")]), _c('el-input', {
      attrs: {
        "type": "number",
        "controls": false
      },
      model: {
        value: (utility.balance),
        callback: function($$v) {
          _vm.$set(utility, "balance", $$v)
        },
        expression: "utility.balance"
      }
    })], 1) : _vm._e(), (_vm.admin) ? _c('div', {
      staticClass: "ui field"
    }, [_c('label', [_vm._v("上次结算度数")]), _c('el-input', {
      attrs: {
        "type": "number",
        "controls": false
      },
      model: {
        value: (_vm.utilities_paid[utility.type]),
        callback: function($$v) {
          _vm.$set(_vm.utilities_paid, utility.type, $$v)
        },
        expression: "utilities_paid[utility.type]"
      }
    })], 1) : _vm._e(), _c('div', {
      staticClass: "ui field"
    }, [_c('label', [_vm._v("机械表 (上次: " + _vm._s(_vm.getPrevMechanical(utility)) + ")")]), _c('el-input', {
      attrs: {
        "type": "number",
        "controls": false
      },
      model: {
        value: (utility.mechanical),
        callback: function($$v) {
          _vm.$set(utility, "mechanical", $$v)
        },
        expression: "utility.mechanical"
      }
    })], 1)])], 1)
  })), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui button",
    class: {
      disabled: !_vm.submitable, themed: _vm.submitable
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.exit
    }
  }, [_vm._v("取消")]), _c('el-checkbox', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "label": "使用管理员权限"
    },
    model: {
      value: (_vm.admin),
      callback: function($$v) {
        _vm.admin = $$v
      },
      expression: "admin"
    }
  })], 1), (!_vm.indialog) ? [_c('h3', [_vm._v("抄表记录")]), _c('el-table', {
    attrs: {
      "data": _vm.history
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "时间"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "_operator_name",
      "label": "操作员"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "water",
      "label": "冷水"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "hot_water",
      "label": "热水"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "electricity",
      "label": "电表"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "kitchen",
      "label": "厨房电"
    }
  })], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f526871c","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/forms/FormUtilities.vue
// module id = 388
// module chunks = 0